import { render, staticRenderFns } from "./IndexNew.vue?vue&type=template&id=4402a1be&scoped=true&"
import script from "./IndexNew.vue?vue&type=script&lang=js&"
export * from "./IndexNew.vue?vue&type=script&lang=js&"
import style0 from "./IndexNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./IndexNew.vue?vue&type=style&index=1&id=4402a1be&lang=scss&scoped=true&"
import style2 from "./IndexNew.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4402a1be",
  null
  
)

export default component.exports